module.exports = __webpack_public_path__ + "img/france-tuberculosis-female.92b8de91.png";